(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orlaven-custom-bomber-configurator-content"] && !Shopify.designMode) return;
  try {
    const colorHexByName = {
    Olive: '#3d4b1e',
    Black: '#111111',
    Charcoal: '#202020',
    'Dark Brown': '#3a261d',
    'Mocha Brown': '#5a3a2d',
    Cognac: '#9a5f35',
    Tan: '#bf8757',
    Burgundy: '#6d1827',
    Maroon: '#650019',
    Navy: '#172845',
    'Royal Blue': '#123c95',
    'Forest Green': '#20392d',
    Grey: '#707070',
    Ivory: '#eee8dc',
    Brown: '#4a3023',
    Silver: '#c8c8c8',
    'Antique Brass': '#9b7a3d',
    Gold: '#c4a04a',
    White: '#ffffff',
    Red: '#b40f24',
    Orange: '#ff7a00',
    Yellow: '#ffe500',
    'Sky Blue': '#94d6f2',
    Blue: '#143f8f',
    Green: '#1f8a25',
    Lime: '#55bf18',
    Purple: '#7b247f',
    Pink: '#ef8ab0',
    'Hot Pink': '#ff3f78',
  };

  const propertyNameFromInput = (input) => {
    const match = input.name && input.name.match(/^properties\[(.*)\]$/);
    return match ? match[1] : '';
  };

  const cleanText = (value, maxLength, preserveLineBreaks = false) => {
    const withoutMarkup = value.replace(/[<>]/g, '');
    const cleaned = preserveLineBreaks
      ? withoutMarkup.replace(/[^\S\r\n]+/g, ' ').replace(/\n{3,}/g, '\n\n').trimStart()
      : withoutMarkup.replace(/\s+/g, ' ').trimStart();
    return maxLength ? cleaned.slice(0, maxLength) : cleaned;
  };

  const initCustomizer = (root) => {
    if (root.dataset.ocbcReady === 'true') return;
    root.dataset.ocbcReady = 'true';

    const form = root.querySelector('form');
    const productForm = root.querySelector('product-form-component');
    const variantInput = root.querySelector('[data-ocbc-variant-input]');
    const sizeProperty = root.querySelector('[data-ocbc-size-property]');
    const priceOutputs = root.querySelectorAll('[data-ocbc-price]');
    const comparePriceOutput = root.querySelector('[data-ocbc-compare-price]');
    const reviewList = root.querySelector('[data-ocbc-review-list]');
    const miniSummary = root.querySelector('[data-ocbc-mini-summary]');
    const activeZoneLabel = root.querySelector('[data-ocbc-active-zone-label]');
    const previewStatus = root.querySelector('[data-ocbc-preview-status]');
    const jsonInput = root.querySelector('[data-ocbc-json]');
    const preview = root.querySelector('[data-ocbc-preview]');
    const guidelinesButton = root.querySelector('[data-ocbc-guidelines]');
    const madeToggle = root.querySelector('[data-ocbc-made-toggle]');
    const measurements = root.querySelector('[data-ocbc-measurements]');
    const addAnotherButton = root.querySelector('[data-ocbc-add-another]');
    const addToCartButton = root.querySelector('[data-testid="orlaven-custom-bomber-add-to-cart"]');
    const madeMessage = root.querySelector('[data-ocbc-made-message]');
    const quantityInput = root.querySelector('[data-ocbc-quantity-input]');
    const quantityControl = root.querySelector('[data-ocbc-quantity-control]');
    const validation = root.querySelector('[data-ocbc-validation]');
    const noteInput = root.querySelector('[data-ocbc-note]');
    const noteCount = root.querySelector('[data-ocbc-note-count]');
    const saveButton = root.querySelector('[data-ocbc-save]');
    const restoreButton = root.querySelector('[data-ocbc-restore]');
    const clearSavedButton = root.querySelector('[data-ocbc-clear-saved]');
    const successPanel = root.querySelector('[data-ocbc-success]');
    const successResetButton = root.querySelector('[data-ocbc-success-reset]');
    const storageKey = `orlaven-custom-bomber:${root.id}`;
    const previewUrls = new Map();
    let state = {};
    let resetAfterAdd = false;
    let isSubmitting = false;
    let submitTimeout = 0;
    let zoom = 1;

    const guidelineLabelForZone = (zoneKey) => {
      if (zoneKey === 'back_top') return 'ADD TOP WORDING';
      if (zoneKey === 'back_middle') return 'ADD MIDDLE ARTWORK';
      if (zoneKey === 'back_bottom') return 'ADD BOTTOM WORDING';
      if (zoneKey.includes('sleeve')) return 'ADD NUMBERS';
      if (zoneKey.includes('pocket')) return 'ADD';
      return 'ADD TEXT / IMAGE';
    };

    const fontFamilyFor = (fontName) => {
      if (fontName === 'Clean Sans') return 'Arial, var(--font-body--family)';
      if (fontName === 'Script') return 'cursive, var(--font-heading--family)';
      if (fontName === 'Orlaven Serif') return 'Georgia, "Times New Roman", serif';
      if (fontName === 'Classic Block') return '"Arial Black", Impact, sans-serif';
      if (fontName === 'Athletic Block') return 'Impact, "Arial Narrow", sans-serif';
      if (fontName === 'Bold Varsity') return 'Rockwell, "Arial Black", serif';
      return 'var(--font-heading--family)';
    };

    const viewLabelFor = (view) => ({
      front: 'front',
      back: 'back',
      left_sleeve: 'left sleeve',
      right_sleeve: 'right sleeve',
    }[view] || 'front');

    const syncReferenceLayers = () => {};
    const applyPreviewMode = () => {};

    const setView = (view) => {
      root.dataset.activeView = view;
      root.querySelectorAll('[data-ocbc-svg-view]').forEach((svg) => {
        const isHidden = svg.dataset.ocbcSvgView !== view;
        svg.toggleAttribute('hidden', isHidden);
        svg.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
      });
      root.querySelectorAll('[data-ocbc-view]').forEach((button) => {
        const active = button.dataset.ocbcView === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      });
      root.querySelectorAll('[data-preview-zone]').forEach((overlay) => {
        const hasContent = overlay.dataset.hasContent === 'true';
        const shouldShow = hasContent || root.classList.contains('has-guidelines');
        if (!hasContent && root.classList.contains('has-guidelines')) {
          overlay.textContent = guidelineLabelForZone(overlay.dataset.previewZone || '');
          overlay.style.fontFamily = 'Arial, sans-serif';
          overlay.style.fontSize = '';
          overlay.style.fontWeight = '400';
          overlay.style.textShadow = 'none';
        }
        overlay.hidden = overlay.dataset.zoneView !== view || !shouldShow;
      });
      if (previewStatus) {
        const activeEditor = root.querySelector(`[data-ocbc-zone-editor="${root.dataset.activeZone || ''}"]`);
        const zoneName = activeEditor?.dataset.zoneLabel;
        previewStatus.textContent = `Viewing ${viewLabelFor(view)}${zoneName ? `. Active placement: ${zoneName}.` : '.'}`;
      }
    };

    const setActiveZone = (zoneKey, openEditor = true) => {
      const editor = root.querySelector(`[data-ocbc-zone-editor="${zoneKey}"]`);
      if (!editor) return;
      root.dataset.activeZone = zoneKey;
      root.querySelectorAll('[data-ocbc-zone-editor]').forEach((candidate) => {
        const isActive = candidate === editor;
        candidate.hidden = !isActive;
        candidate.classList.toggle('is-active', isActive);
      });
      root.querySelectorAll('[data-ocbc-zone-row]').forEach((row) => {
        const isActive = row.dataset.ocbcZoneRow === zoneKey;
        row.classList.toggle('is-active', isActive);
        row.open = isActive && openEditor;
      });
      root.querySelectorAll('[data-ocbc-zone-button]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.ocbcZoneButton === zoneKey);
      });
      root.querySelectorAll('[data-preview-zone]').forEach((overlay) => {
        overlay.classList.toggle('is-active', overlay.dataset.previewZone === zoneKey);
      });
      if (activeZoneLabel) activeZoneLabel.textContent = editor.dataset.zoneLabel || '';
      setView(editor.dataset.zoneView || 'front');
    };

    const setControlState = (editor, selector, enabled, required = false) => {
      editor.querySelectorAll(selector).forEach((field) => {
        field.disabled = !enabled;
        field.required = enabled && required;
      });
    };

    const clearArtworkPreview = (zoneKey) => {
      const previous = previewUrls.get(zoneKey);
      if (previous?.url) URL.revokeObjectURL(previous.url);
      previewUrls.delete(zoneKey);
    };

    const validateArtwork = (input) => {
      const editor = input.closest('[data-ocbc-zone-editor]');
      const zoneKey = editor?.dataset.ocbcZoneEditor || '';
      const status = editor?.querySelector('[data-ocbc-file-status]');
      const removeButton = editor?.querySelector('[data-ocbc-remove-artwork]');
      const file = input.files?.[0];
      clearArtworkPreview(zoneKey);

      if (!file) {
        if (status) status.textContent = '';
        if (removeButton) removeButton.hidden = true;
        return true;
      }

      const allowed = /\.(png|jpe?g|webp|pdf)$/i.test(file.name);
      if (!allowed || file.size > 5 * 1024 * 1024) {
        input.value = '';
        if (status) status.textContent = allowed ? 'Choose an artwork file smaller than 5 MB.' : 'Choose a PNG, JPG, WEBP, or PDF artwork file.';
        if (removeButton) removeButton.hidden = true;
        return false;
      }

      const previewable = /^image\/(png|jpeg|webp)$/i.test(file.type);
      if (previewable) previewUrls.set(zoneKey, { url: URL.createObjectURL(file), fileName: file.name });
      if (status) status.textContent = `${file.name} selected${previewable ? ' and previewed' : ''}.`;
      if (removeButton) removeButton.hidden = false;
      return true;
    };

    const syncInkPicker = (editor) => {
      const picker = editor.querySelector('[data-ocbc-ink-picker]');
      if (!picker) return;

      let target = picker.dataset.ocbcInkTarget || 'fill';
      let control = editor.querySelector(`[data-zone-property="${target}"]`);
      if (!control || control.disabled) {
        target = 'fill';
        control = editor.querySelector('[data-zone-property="fill"]');
        picker.dataset.ocbcInkTarget = target;
      }

      const selectedValue = control?.value || '';
      picker.querySelectorAll('[data-ocbc-ink-tab]').forEach((tab) => {
        const isActive = tab.dataset.ocbcInkTab === target;
        const tabControl = editor.querySelector(`[data-zone-property="${tab.dataset.ocbcInkTab}"]`);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.disabled = Boolean(tabControl?.disabled);
      });
      picker.querySelectorAll('[data-ocbc-ink-color]').forEach((swatch) => {
        const value = swatch.dataset.ocbcInkColor || '';
        const isNoneOption = value === '';
        swatch.hidden = target === 'fill' && isNoneOption;
        const isSelected = value === selectedValue;
        swatch.classList.toggle('is-selected', isSelected);
        swatch.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    };

    const syncZone = (editor) => {
      const mode = editor.querySelector('[data-zone-mode]:checked')?.value || '';
      const typeInput = editor.querySelector('[data-zone-property="type"]');
      const textInput = editor.querySelector('[data-zone-property="text"]');
      const letterInput = editor.querySelector('[data-zone-property="letter"]');
      const fontInput = editor.querySelector('[data-zone-property="font"]');
      const fontSizeInput = editor.querySelector('[data-zone-property="fontSize"]');
      const fillInput = editor.querySelector('[data-zone-property="fill"]');
      const strokeInput = editor.querySelector('[data-zone-property="stroke1"]');
      const stroke2Input = editor.querySelector('[data-zone-property="stroke2"]');
      const removeStrokeInput = editor.querySelector('[data-zone-property="removeStroke"]');
      const artworkInput = editor.querySelector('[data-zone-property="artwork"]');
      const artworkSizeInput = editor.querySelector('[data-zone-property="artworkSize"]');
      const artworkNoteInput = editor.querySelector('[data-zone-property="artworkNote"]');
      const positionXInput = editor.querySelector('[data-zone-property="positionX"]');
      const positionYInput = editor.querySelector('[data-zone-property="positionY"]');
      const rotationInput = editor.querySelector('[data-zone-property="rotation"]');
      const scaleInput = editor.querySelector('[data-zone-property="scale"]');
      const letterStyleInput = editor.querySelector('[data-zone-property="letterStyle"]:checked');
      const removeArtworkButton = editor.querySelector('[data-ocbc-remove-artwork]');
      const overlay = root.querySelector(`[data-preview-zone="${editor.dataset.ocbcZoneEditor}"]`);
      const limit = Number(editor.dataset.zoneLimit) || 24;
      const isText = mode === 'Text / Name';
      const isLetter = mode === 'Letter / Initial';
      const isImage = mode === 'Image / Artwork';
      const usesStyle = isText || isLetter;
      const hasDesign = usesStyle || isImage;

      if (textInput) textInput.value = cleanText(textInput.value, limit);
      if (letterInput) letterInput.value = cleanText(letterInput.value.toUpperCase(), 3);

      if (typeInput) {
        typeInput.value = mode;
        typeInput.disabled = mode === '';
      }

      setControlState(editor, '[data-zone-property="text"]', isText, false);
      setControlState(editor, '[data-zone-property="letter"]', isLetter, false);
      setControlState(editor, '[data-zone-property="font"], [data-zone-property="fontSize"], [data-zone-property="fill"], [data-zone-property="stroke1"], [data-zone-property="stroke2"], [data-zone-property="removeStroke"]', usesStyle, false);
      setControlState(editor, '[data-zone-property="letterStyle"]', isLetter, false);
      setControlState(editor, '[data-zone-property="artwork"], [data-zone-property="artworkSize"], [data-zone-property="artworkNote"]', isImage, false);
      setControlState(editor, '[data-zone-property="positionX"], [data-zone-property="positionY"], [data-zone-property="rotation"], [data-zone-property="scale"]', hasDesign, false);

      if (removeStrokeInput?.checked) {
        if (strokeInput) strokeInput.disabled = true;
        if (stroke2Input) stroke2Input.disabled = true;
      }

      editor.querySelectorAll('[data-mode-control]').forEach((group) => {
        const control = group.dataset.modeControl;
        group.hidden =
          (control === 'text' && !isText) ||
          (control === 'letter' && !isLetter) ||
          (control === 'letterStyle' && !isLetter) ||
          (control === 'style' && !usesStyle) ||
          (control === 'image' && !isImage) ||
          (control === 'transform' && !hasDesign);
      });

      const count = editor.querySelector('[data-count-for="text"]');
      if (count && textInput) count.textContent = `${textInput.value.length}/${limit}`;

      let overlayText = '';
      if (isText && textInput?.value.trim()) overlayText = textInput.value.trim();
      if (isLetter && letterInput?.value.trim()) overlayText = letterInput.value.trim();
      const artworkFile = artworkInput?.files?.[0];
      const artworkPreview = previewUrls.get(editor.dataset.ocbcZoneEditor || '');
      const hasArtwork = isImage && Boolean(artworkFile);
      if (hasArtwork && !artworkPreview?.url) overlayText = artworkFile?.name.toLowerCase().endsWith('.pdf') ? 'Artwork PDF' : 'Artwork';
      if (removeArtworkButton) removeArtworkButton.hidden = !artworkFile;

      if (overlay) {
        const guideText = guidelineLabelForZone(editor.dataset.ocbcZoneEditor || '');
        const hasContent = Boolean(overlayText) || hasArtwork;
        overlay.dataset.hasContent = hasContent ? 'true' : 'false';
        const displayText = overlayText || (!hasContent && root.classList.contains('has-guidelines') ? guideText : '');
        if (isLetter && overlayText) {
          overlay.replaceChildren(...Array.from(overlayText).map((character) => {
            const span = document.createElement('span');
            span.textContent = character;
            return span;
          }));
        } else {
          overlay.textContent = displayText;
        }
        overlay.classList.toggle('is-guide', !hasContent);
        const hasPreviewImage = isImage && Boolean(artworkPreview?.url);
        overlay.classList.toggle('is-image', hasPreviewImage);
        overlay.classList.toggle('is-letter', isLetter && Boolean(overlayText));
        overlay.dataset.letterStyle = isLetter ? letterStyleInput?.value || 'Standard' : '';
        overlay.style.setProperty('--overlay-image', hasPreviewImage ? `url("${artworkPreview.url}")` : 'none');
        overlay.hidden = !overlay.textContent || overlay.dataset.zoneView !== root.dataset.activeView;
        if (hasPreviewImage) overlay.hidden = overlay.dataset.zoneView !== root.dataset.activeView;
        const threadHex = (value, fallback) => {
          if (!value) return fallback;
          const matchingSwatch = Array.from(editor.querySelectorAll('[data-ocbc-ink-color]'))
            .find((swatch) => swatch.dataset.ocbcInkColor === value);
          return matchingSwatch?.dataset.ocbcInkHex || colorHexByName[value] || fallback;
        };
        overlay.style.setProperty('--overlay-fill', threadHex(fillInput?.value, '#111111'));
        overlay.style.setProperty('--overlay-stroke', threadHex(strokeInput?.value, 'transparent'));
        overlay.style.setProperty('--overlay-stroke-2', threadHex(stroke2Input?.value, 'transparent'));
        overlay.style.setProperty('--overlay-x', `${Number(positionXInput?.value) || 0}px`);
        overlay.style.setProperty('--overlay-y', `${Number(positionYInput?.value) || 0}px`);
        overlay.style.setProperty('--overlay-rotation', `${Number(rotationInput?.value) || 0}deg`);
        overlay.style.setProperty('--overlay-scale', String((Number(scaleInput?.value) || 100) / 100));
        overlay.style.textShadow = removeStrokeInput?.checked ? 'none' : '';
        const sizeValue = isImage ? artworkSizeInput?.value || '' : fontSizeInput?.value || '';
        const sizeNumber = Number(sizeValue.replace(/[^0-9.]/g, '')) || 5;
        overlay.style.fontSize = `${Math.min(42, Math.max(14, sizeNumber * 3.1))}px`;
        overlay.style.setProperty('--overlay-art-size', `${Math.min(150, Math.max(38, sizeNumber * 10))}px`);
        overlay.style.fontFamily = fontFamilyFor(fontInput?.value);
      }

      editor.querySelectorAll('[data-range-output]').forEach((output) => {
        const field = editor.querySelector(`[data-zone-property="${output.dataset.rangeOutput}"]`);
        if (!field) return;
        if (output.dataset.rangeOutput === 'rotation') output.textContent = `${field.value}\u00b0`;
        else if (output.dataset.rangeOutput === 'scale') output.textContent = `${field.value}%`;
        else output.textContent = field.value;
      });

      syncInkPicker(editor);
    };

    const syncAllZones = () => {
      root.querySelectorAll('[data-ocbc-zone-editor]').forEach(syncZone);
      setView(root.dataset.activeView || 'front');
    };

    const readProperty = (key) => root.querySelector(`[data-ocbc-property="${key}"]`)?.value.trim() || '';

    const updateReferenceMode = () => {};

    const buildState = () => {
      const placements = {};
      root.querySelectorAll('[data-ocbc-zone-editor]').forEach((editor) => {
        const mode = editor.querySelector('[data-zone-mode]:checked')?.value || '';
        if (!mode) return;
        const zoneKey = editor.dataset.ocbcZoneEditor || '';
        const artwork = editor.querySelector('[data-zone-property="artwork"]')?.files?.[0];
        const removeStroke = editor.querySelector('[data-zone-property="removeStroke"]')?.checked || false;
        const isText = mode === 'Text / Name';
        const isLetter = mode === 'Letter / Initial';
        const isImage = mode === 'Image / Artwork';
        placements[zoneKey] = {
          label: editor.dataset.zoneLabel || zoneKey,
          type: mode,
          text: isText ? editor.querySelector('[data-zone-property="text"]')?.value.trim() || '' : '',
          letter: isLetter ? editor.querySelector('[data-zone-property="letter"]')?.value.trim() || '' : '',
          font: isText || isLetter ? editor.querySelector('[data-zone-property="font"]')?.value || '' : '',
          fontSize: isText || isLetter ? editor.querySelector('[data-zone-property="fontSize"]')?.value || '' : '',
          letterStyle: isLetter ? editor.querySelector('[data-zone-property="letterStyle"]:checked')?.value || '' : '',
          fill: isText || isLetter ? editor.querySelector('[data-zone-property="fill"]')?.value || '' : '',
          stroke1: isText || isLetter ? (removeStroke ? '' : editor.querySelector('[data-zone-property="stroke1"]')?.value || '') : '',
          stroke2: isText || isLetter ? (removeStroke ? '' : editor.querySelector('[data-zone-property="stroke2"]')?.value || '') : '',
          removeStroke: (isText || isLetter) && removeStroke,
          artwork: isImage ? artwork?.name || '' : '',
          artworkSize: isImage ? editor.querySelector('[data-zone-property="artworkSize"]')?.value || '' : '',
          artworkNote: isImage ? editor.querySelector('[data-zone-property="artworkNote"]')?.value.trim() || '' : '',
          positionX: editor.querySelector('[data-zone-property="positionX"]')?.value || '0',
          positionY: editor.querySelector('[data-zone-property="positionY"]')?.value || '0',
          rotation: editor.querySelector('[data-zone-property="rotation"]')?.value || '0',
          scale: editor.querySelector('[data-zone-property="scale"]')?.value || '100',
        };
      });

      const measurementValues = {};
      root.querySelectorAll('[data-ocbc-measure-input]:not(:disabled)').forEach((input) => {
        const name = propertyNameFromInput(input);
        if (name && input.value.trim()) measurementValues[name] = input.value.trim();
      });

      const standardSize = root.querySelector('[data-ocbc-variant-id].is-selected')?.dataset.ocbcVariantTitle || '';
      return {
        base: {
          jacketStyle: root.querySelector('[name="properties[Jacket Style]"]')?.value || 'Bomber Jacket',
          fit: readProperty('fit'),
          material: readProperty('material'),
          closure: readProperty('closure'),
          pocket: readProperty('pocket'),
          trimStyle: readProperty('trim-style'),
          lining: readProperty('lining'),
          insulation: readProperty('insulation'),
          decoration: readProperty('decoration'),
        },
        colors: {
          body: readProperty('body-color'),
          sleeves: readProperty('sleeve-color'),
          rib: readProperty('rib-color'),
          zip: readProperty('zip-color'),
          hardware: readProperty('hardware-color'),
          lining: readProperty('lining-color'),
          stitching: readProperty('stitching-color'),
          pocketTrim: readProperty('pocket-trim-color'),
        },
        placements,
        size: {
          type: madeToggle?.checked ? 'made-to-measure' : 'standard',
          value: madeToggle?.checked ? 'Custom / Made to Measure' : standardSize,
          standardSize,
          measurements: measurementValues,
        },
        note: noteInput?.value.trim() || '',
      };
    };

    const syncState = () => {
      if (noteInput) noteInput.value = cleanText(noteInput.value, 500, true);
      state = buildState();
      root.dataset.ocbcClosure = state.base.closure;
      root.dataset.ocbcPocket = state.base.pocket;
      root.dataset.ocbcMaterial = state.base.material;
      root.dataset.ocbcTrimStyle = state.base.trimStyle;
      root.dataset.ocbcLining = state.base.lining;
      if (sizeProperty) sizeProperty.value = state.size.value;
      if (noteCount) noteCount.textContent = `${state.note.length}/500`;
    };

    const updateReview = () => {
      if (!reviewList) return;
      const rows = [
        ['Jacket Style', state.base.jacketStyle],
        ['Fit', state.base.fit],
        ['Material', state.base.material],
        ['Front Closure', state.base.closure],
        ['Pocket Style', state.base.pocket],
        ['Collar / Cuffs / Waistband', state.base.trimStyle],
        ['Lining', state.base.lining],
        ['Insulation', state.base.insulation],
        ['Decoration Method', state.base.decoration],
        ['Body Color', state.colors.body],
        ['Sleeve Color', state.colors.sleeves],
        ['Rib Color', state.colors.rib],
        ['Zip Color', state.colors.zip],
        ['Hardware Color', state.colors.hardware],
        ['Lining Color', state.colors.lining],
        ['Stitching Color', state.colors.stitching],
        ['Pocket Trim Color', state.colors.pocketTrim],
        ['Size', state.size.value],
      ].filter(([, value]) => value);

      Object.values(state.placements).forEach((placement) => {
        const content = placement.text || placement.letter || placement.artwork;
        const type = placement.type.replace(' / ', ' ');
        const style = placement.font ? `, ${placement.font}` : '';
        const size = placement.fontSize || placement.artworkSize ? `, ${placement.fontSize || placement.artworkSize}` : '';
        const letterStyle = placement.letterStyle ? `, ${placement.letterStyle}` : '';
        const fill = placement.fill ? `, fill ${placement.fill}` : '';
        const strokes = placement.removeStroke
          ? ', no stroke'
          : [placement.stroke1 && `stroke 1 ${placement.stroke1}`, placement.stroke2 && `stroke 2 ${placement.stroke2}`]
            .filter(Boolean)
            .map((value) => `, ${value}`)
            .join('');
        const artworkNote = placement.artworkNote ? `, note: ${placement.artworkNote}` : '';
        const adjusted = Number(placement.positionX) || Number(placement.positionY) || Number(placement.rotation) || Number(placement.scale) !== 100;
        const transform = adjusted ? `, adjusted (${placement.positionX}/${placement.positionY}, ${placement.rotation}\u00b0, ${placement.scale}%)` : '';
        rows.push([placement.label, `${type}${content ? `: ${content}` : ''}${style}${size}${letterStyle}${fill}${strokes}${artworkNote}${transform}`]);
      });

      Object.entries(state.size.measurements).forEach(([label, value]) => rows.push([label, value]));
      if (state.note) rows.push(['Production Note', state.note]);

      reviewList.replaceChildren();
      rows.forEach(([label, value]) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        row.dataset.reviewRow = '';
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        reviewList.append(row);
      });

      if (miniSummary) {
        miniSummary.textContent = `${state.colors.body || 'Light Grey'} ${(state.base.material || 'Nylon').toLowerCase()} bomber${state.size.value ? `, size ${state.size.value}` : ''}.`;
      }
    };

    const updateJson = () => {
      if (!jsonInput) return;
      jsonInput.value = JSON.stringify(state);
    };

    let refreshFrame = 0;
    let dataRefreshTimer = 0;
    let pendingEditor = null;
    let pendingFullVisualRefresh = true;

    const commitDataRefresh = () => {
      dataRefreshTimer = 0;
      syncState();
      updateReview();
      updateJson();
    };

    const commitVisualRefresh = () => {
      refreshFrame = 0;
      if (pendingFullVisualRefresh || !pendingEditor) {
        syncAllZones();
      } else {
        syncZone(pendingEditor);
        setView(root.dataset.activeView || 'front');
      }
      pendingEditor = null;
      pendingFullVisualRefresh = false;
    };

    const refresh = (options = {}) => {
      const shouldUpdateVisual = options.visual !== false;
      const shouldUpdateData = options.data !== false;

      if (options.immediate) {
        if (refreshFrame) {
          window.cancelAnimationFrame(refreshFrame);
          refreshFrame = 0;
        }
        if (dataRefreshTimer) {
          window.clearTimeout(dataRefreshTimer);
          dataRefreshTimer = 0;
        }
        pendingEditor = null;
        pendingFullVisualRefresh = true;
        syncAllZones();
        commitDataRefresh();
        return;
      }

      if (shouldUpdateVisual) {
        if (options.editor && !pendingFullVisualRefresh) {
          pendingEditor = options.editor;
        } else {
          pendingFullVisualRefresh = true;
          pendingEditor = null;
        }
        if (!refreshFrame) refreshFrame = window.requestAnimationFrame(commitVisualRefresh);
      }

      if (shouldUpdateData) {
        if (dataRefreshTimer) window.clearTimeout(dataRefreshTimer);
        const delay = Number.isFinite(options.dataDelay) ? options.dataDelay : 120;
        dataRefreshTimer = window.setTimeout(commitDataRefresh, delay);
      }
    };

    const syncMadeToMeasure = ({ clearDisabled = false } = {}) => {
      if (!madeToggle || !measurements) return;
      const enabled = madeToggle.checked;
      measurements.hidden = !enabled;
      if (madeMessage) madeMessage.hidden = !enabled;
      measurements.querySelectorAll('[data-ocbc-measure-input]').forEach((field) => {
        if (!enabled && clearDisabled) {
          if (field.tagName === 'SELECT') field.selectedIndex = 0;
          else field.value = '';
        }
        field.disabled = !enabled;
        field.required = enabled && field.tagName === 'INPUT';
      });
    };

    const updateSavedControls = () => {
      if (!restoreButton || !clearSavedButton) return;
      try {
        const hasSaved = Boolean(localStorage.getItem(storageKey));
        restoreButton.hidden = !hasSaved;
        clearSavedButton.hidden = !hasSaved;
      } catch (error) {
        restoreButton.hidden = true;
        clearSavedButton.hidden = true;
      }
    };

    const showValidation = (messages, focusSelector) => {
      if (!validation) return;
      validation.hidden = messages.length === 0;
      validation.textContent = messages.length ? messages.join(' ') : '';
      if (messages.length && focusSelector) {
        const target = root.querySelector(focusSelector);
        const editor = target?.closest('[data-ocbc-zone-editor]');
        const step = target?.closest('.ocbc__step');
        if (editor) {
          const artworkStep = root.querySelector('.ocbc__step--artwork');
          if (artworkStep) artworkStep.open = true;
          setActiveZone(editor.dataset.ocbcZoneEditor || 'right_chest', true);
        } else if (step) {
          step.open = true;
        }
        window.requestAnimationFrame(() => {
          target?.focus({ preventScroll: true });
          target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      } else if (messages.length) {
        validation.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    const validateBeforeSubmit = () => {
      refresh({ immediate: true });
      const errors = [];
      let firstSelector = '';

      if (!variantInput?.value) {
        errors.push('Choose an available jacket size.');
        firstSelector = '[data-ocbc-variant-id]:not([disabled])';
      }

      if (madeToggle?.checked) {
        const requiredMeasurements = Array.from(root.querySelectorAll('[data-ocbc-measure-input]'))
          .filter((field) => field.tagName === 'INPUT');
        const missingMeasurement = requiredMeasurements.find((field) => !field.value.trim());
        if (missingMeasurement) {
          errors.push('Complete all required made-to-measure fields.');
          firstSelector ||= '[data-ocbc-measure-input][type="number"]';
        } else {
          const invalidMeasurement = requiredMeasurements.find((field) => !field.checkValidity());
          if (invalidMeasurement) {
            errors.push('Enter realistic measurements within the allowed ranges.');
            firstSelector ||= '[data-ocbc-measure-input][type="number"]:invalid';
          }
        }
      }

      root.querySelectorAll('[data-ocbc-zone-editor]').forEach((editor) => {
        const mode = editor.querySelector('[data-zone-mode]:checked')?.value || '';
        const label = editor.dataset.zoneLabel || 'Artwork placement';
        const text = editor.querySelector('[data-zone-property="text"]')?.value.trim() || '';
        const letter = editor.querySelector('[data-zone-property="letter"]')?.value.trim() || '';
        const artwork = editor.querySelector('[data-zone-property="artwork"]')?.files?.[0];
        const editorSelector = `[data-ocbc-zone-editor="${editor.dataset.ocbcZoneEditor}"]`;
        if (mode === 'Text / Name' && !text) {
          errors.push(`${label} needs a name.`);
          firstSelector ||= `${editorSelector} [data-zone-property="text"]`;
        }
        if (mode === 'Letter / Initial' && !letter) {
          errors.push(`${label} needs a letter.`);
          firstSelector ||= `${editorSelector} [data-zone-property="letter"]`;
        }
        if (mode === 'Image / Artwork' && !artwork) {
          errors.push(`${label} needs an artwork file.`);
          firstSelector ||= `${editorSelector} [data-ocbc-artwork-input]`;
        }
      });

      showValidation(errors, firstSelector);
      return errors.length === 0;
    };

    const setSubmitting = (active, timeoutMessage = '') => {
      isSubmitting = active;
      root.toggleAttribute('data-ocbc-submitting', active);
      if (addAnotherButton) addAnotherButton.disabled = active;
      if (addToCartButton) addToCartButton.disabled = active;
      if (submitTimeout) {
        window.clearTimeout(submitTimeout);
        submitTimeout = 0;
      }
      if (active) {
        submitTimeout = window.setTimeout(() => {
          setSubmitting(false);
          resetAfterAdd = false;
          showValidation([timeoutMessage || 'We could not confirm the cart update. Check your connection and try again.']);
        }, 15000);
      }
    };

    const resetCustomizer = () => {
      form?.reset();
      previewUrls.forEach(({ url }) => URL.revokeObjectURL(url));
      previewUrls.clear();
      root.querySelectorAll('[data-ocbc-artwork-input]').forEach((input) => { input.value = ''; });
      root.querySelectorAll('[data-ocbc-property]').forEach((input) => {
        const initialValue = input.getAttribute('value');
        if (initialValue !== null) input.value = initialValue;
      });
      root.querySelectorAll('[data-ocbc-color-target]').forEach((button) => {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });
      root.querySelectorAll('[data-ocbc-swatch-group]').forEach((group) => {
        const target = group.dataset.ocbcSwatchGroup;
        const value = root.querySelector(`[data-ocbc-property="${target}"]`)?.value;
        const defaultButton = Array.from(group.querySelectorAll('[data-ocbc-color-target]'))
          .find((button) => button.dataset.ocbcColor === value);
        if (defaultButton) applyColorSelection(defaultButton);
      });
      let defaultVariantButton = null;
      root.querySelectorAll('[data-ocbc-variant-id]').forEach((button) => {
        const active = button.dataset.ocbcVariantId === variantInput?.defaultValue;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-checked', active ? 'true' : 'false');
        if (active) {
          defaultVariantButton = button;
          if (variantInput) variantInput.value = button.dataset.ocbcVariantId || '';
        }
      });
      if (defaultVariantButton) {
        priceOutputs.forEach((output) => { output.textContent = defaultVariantButton.dataset.ocbcVariantPrice || ''; });
        if (comparePriceOutput) {
          comparePriceOutput.textContent = defaultVariantButton.dataset.ocbcVariantComparePrice || '';
          comparePriceOutput.hidden = !defaultVariantButton.dataset.ocbcVariantComparePrice;
        }
      }
      if (quantityControl) quantityControl.value = '1';
      if (quantityInput) quantityInput.value = '1';
      if (madeToggle) madeToggle.checked = false;
      syncMadeToMeasure();
      root.querySelectorAll('[data-ocbc-file-status]').forEach((status) => { status.textContent = ''; });
      root.querySelectorAll('[data-ocbc-remove-artwork]').forEach((button) => { button.hidden = true; });
      root.querySelectorAll('[data-ocbc-zone-editor]').forEach((editor) => editor.querySelector('[data-zone-mode][value=""]')?.click());
      if (successPanel) successPanel.hidden = true;
      if (validation) validation.hidden = true;
      setSubmitting(false);
      resetAfterAdd = false;
      zoom = 1;
      if (preview) preview.style.setProperty('--ocbc-zoom', '1');
      updateReferenceMode();
      setActiveZone('right_chest');
      setView('front');
      refresh({ immediate: true });
    };

    const restoreSavedDesign = () => {
      let saved;
      try {
        saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      } catch (error) {
        saved = null;
      }
      if (!saved) return;

      const basePropertyMap = {
        fit: 'fit',
        material: 'material',
        closure: 'closure',
        pocket: 'pocket',
        trimStyle: 'trim-style',
        lining: 'lining',
        insulation: 'insulation',
        decoration: 'decoration',
      };
      Object.entries(basePropertyMap).forEach(([key, target]) => {
        const field = root.querySelector(`[data-ocbc-property="${target}"]`);
        const savedValue = saved.base?.[key];
        if (!savedValue) return;
        if (field) field.value = savedValue;
        root.querySelectorAll(`[data-ocbc-target="${target}"]`).forEach((control) => {
          if (control.type === 'radio') control.checked = control.value === savedValue;
          else control.value = savedValue;
        });
      });
      const colorPropertyMap = {
        body: 'body-color',
        sleeves: 'sleeve-color',
        rib: 'rib-color',
        zip: 'zip-color',
        hardware: 'hardware-color',
        lining: 'lining-color',
        stitching: 'stitching-color',
        pocketTrim: 'pocket-trim-color',
      };
      Object.entries(saved.colors || {}).forEach(([key, value]) => {
        const target = colorPropertyMap[key];
        if (!target) return;
        const button = Array.from(root.querySelectorAll(`[data-ocbc-color-target="${target}"]`))
          .find((candidate) => candidate.dataset.ocbcColor === value);
        if (button) applyColorSelection(button);
      });
      Object.entries(saved.placements || {}).forEach(([zoneKey, placement]) => {
        const editor = root.querySelector(`[data-ocbc-zone-editor="${zoneKey}"]`);
        if (!editor) return;
        editor.querySelectorAll('[data-zone-mode]').forEach((mode) => { mode.checked = mode.value === placement.type; });
        Object.entries(placement).forEach(([key, value]) => {
          if (key === 'artwork') return;
          if (key === 'letterStyle') {
            editor.querySelectorAll('[data-zone-property="letterStyle"]').forEach((radio) => {
              radio.checked = radio.value === value;
            });
            return;
          }
          if (key === 'removeStroke') {
            const checkbox = editor.querySelector('[data-zone-property="removeStroke"]');
            if (checkbox) checkbox.checked = Boolean(value);
            return;
          }
          const field = editor.querySelector(`[data-zone-property="${key}"]`);
          if (field && typeof value === 'string') field.value = value;
        });
        if (placement.artwork) {
          const status = editor.querySelector('[data-ocbc-file-status]');
          if (status) status.textContent = `Re-select ${placement.artwork} to attach this artwork file.`;
        }
      });
      if (madeToggle) madeToggle.checked = saved.size?.type === 'made-to-measure';
      syncMadeToMeasure();
      Object.entries(saved.size?.measurements || {}).forEach(([name, value]) => {
        const field = Array.from(root.querySelectorAll('[data-ocbc-measure-input]'))
          .find((candidate) => propertyNameFromInput(candidate) === name);
        if (field) field.value = value;
      });
      if (saved.size?.type !== 'made-to-measure' && saved.size?.standardSize) {
        const button = Array.from(root.querySelectorAll('[data-ocbc-variant-id]'))
          .find((candidate) => candidate.dataset.ocbcVariantTitle === saved.size.standardSize);
        button?.click();
      }
      if (noteInput) noteInput.value = saved.note || '';
      updateReferenceMode();
      setActiveZone('right_chest');
      refresh({ immediate: true });
      if (previewStatus) previewStatus.textContent = 'Saved design restored. Re-select any saved artwork file before adding to cart.';
    };

    const applyColorSelection = (button) => {
      const target = button.dataset.ocbcColorTarget;
      const cssTarget = button.dataset.ocbcCssTarget;
      const value = button.dataset.ocbcColor || '';
      const hex = button.dataset.ocbcColorHex || '';
      root.querySelectorAll(`[data-ocbc-color-target="${target}"]`).forEach((candidate) => {
        candidate.classList.toggle('is-selected', candidate === button);
        candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
      });
      const input = root.querySelector(`[data-ocbc-property="${target}"]`);
      const label = root.querySelector(`[data-ocbc-current="${target}"]`);
      if (input) input.value = value;
      if (label) label.textContent = value;
      if (cssTarget && hex) root.style.setProperty(`--ocbc-${cssTarget}`, hex);
    };

    root.querySelectorAll('[data-ocbc-target]').forEach((field) => {
      field.addEventListener('change', () => {
        const target = root.querySelector(`[data-ocbc-property="${field.dataset.ocbcTarget}"]`);
        if (target) target.value = field.value;
        refresh({ visual: false, dataDelay: 0 });
      });
    });

    root.querySelectorAll('[data-ocbc-color-target]').forEach((button) => {
      button.addEventListener('click', () => {
        applyColorSelection(button);
        refresh({ visual: false, dataDelay: 40 });
      });
    });

    root.querySelectorAll('[data-ocbc-ink-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const editor = tab.closest('[data-ocbc-zone-editor]');
        const picker = tab.closest('[data-ocbc-ink-picker]');
        if (!editor || !picker || tab.disabled) return;
        picker.dataset.ocbcInkTarget = tab.dataset.ocbcInkTab || 'fill';
        syncInkPicker(editor);
      });
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const tabs = Array.from(tab.parentElement?.querySelectorAll('[data-ocbc-ink-tab]:not(:disabled)') || []);
        if (!tabs.length) return;
        event.preventDefault();
        const currentIndex = tabs.indexOf(tab);
        const nextIndex = event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? tabs.length - 1
            : (currentIndex + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[nextIndex]?.focus();
        tabs[nextIndex]?.click();
      });
    });

    root.querySelectorAll('[data-ocbc-ink-color]').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const editor = swatch.closest('[data-ocbc-zone-editor]');
        const picker = swatch.closest('[data-ocbc-ink-picker]');
        const target = picker?.dataset.ocbcInkTarget || 'fill';
        const control = editor?.querySelector(`[data-zone-property="${target}"]`);
        if (!editor || !control || control.disabled) return;
        const value = swatch.dataset.ocbcInkColor || '';
        if (target === 'fill' && !value) return;
        control.value = value;
        syncInkPicker(editor);
        refresh({ editor, dataDelay: 80 });
      });
    });

    root.querySelectorAll('[data-ocbc-view]').forEach((button) => {
      button.addEventListener('click', () => setView(button.dataset.ocbcView || 'front'));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const buttons = Array.from(root.querySelectorAll('[data-ocbc-view]'));
        event.preventDefault();
        const currentIndex = buttons.indexOf(button);
        const nextIndex = event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? buttons.length - 1
            : (currentIndex + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[nextIndex]?.focus();
        buttons[nextIndex]?.click();
      });
    });

    root.querySelectorAll('.ocbc__substep').forEach((substep) => {
      substep.addEventListener('toggle', () => {
        if (!substep.open) return;
        substep.parentElement?.querySelectorAll(':scope > .ocbc__substep').forEach((sibling) => {
          if (sibling !== substep) sibling.open = false;
        });
      });
    });

    root.querySelectorAll('.ocbc__step').forEach((step) => {
      step.addEventListener('toggle', () => {
        if (!step.open) return;
        root.querySelectorAll('.ocbc__step').forEach((sibling) => {
          if (sibling !== step) sibling.open = false;
        });
      });
    });

    guidelinesButton?.addEventListener('click', () => {
      const active = !root.classList.contains('has-guidelines');
      root.classList.toggle('has-guidelines', active);
      guidelinesButton.setAttribute('aria-pressed', active ? 'true' : 'false');
      refresh({ data: false });
    });

    root.querySelectorAll('[data-ocbc-zone-button]').forEach((button) => {
      button.addEventListener('click', () => setActiveZone(button.dataset.ocbcZoneButton));
    });

    root.querySelectorAll('[data-ocbc-zone-row]').forEach((row) => {
      row.addEventListener('toggle', () => {
        if (row.open && row.dataset.ocbcZoneRow !== root.dataset.activeZone) {
          setActiveZone(row.dataset.ocbcZoneRow);
        }
      });
    });

    root.querySelectorAll('[data-preview-zone]').forEach((overlay) => {
      overlay.addEventListener('click', () => {
        setActiveZone(overlay.dataset.previewZone);
      });
      overlay.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setActiveZone(overlay.dataset.previewZone);
      });
    });

    root.querySelectorAll('[data-ocbc-zone-editor] input, [data-ocbc-zone-editor] select').forEach((field) => {
      field.addEventListener('input', () => {
        refresh({ editor: field.closest('[data-ocbc-zone-editor]') });
      });
      field.addEventListener('change', () => {
        refresh({ editor: field.closest('[data-ocbc-zone-editor]'), dataDelay: 0 });
      });
    });

    root.querySelectorAll('[data-ocbc-clear-zone]').forEach((button) => {
      button.addEventListener('click', () => {
        const editor = root.querySelector(`[data-ocbc-zone-editor="${button.dataset.ocbcClearZone}"]`);
        if (!editor) return;
        clearArtworkPreview(button.dataset.ocbcClearZone);
        const noDesign = editor.querySelector('[data-zone-mode][value=""]');
        if (noDesign) noDesign.checked = true;
        editor.querySelectorAll('[data-zone-property]').forEach((field) => {
          if (field.type === 'radio') field.checked = field.defaultChecked;
          else if (field.type === 'checkbox') field.checked = false;
          else if (field.tagName === 'SELECT') {
            const defaultIndex = Array.from(field.options).findIndex((option) => option.defaultSelected);
            field.selectedIndex = defaultIndex >= 0 ? defaultIndex : 0;
          } else {
            field.value = field.defaultValue || '';
          }
        });
        const status = editor.querySelector('[data-ocbc-file-status]');
        if (status) status.textContent = '';
        const removeButton = editor.querySelector('[data-ocbc-remove-artwork]');
        if (removeButton) removeButton.hidden = true;
        refresh({ editor, dataDelay: 0 });
      });
    });

    root.querySelectorAll('[data-ocbc-artwork-input]').forEach((input) => {
      input.addEventListener('change', () => {
        validateArtwork(input);
        refresh({ editor: input.closest('[data-ocbc-zone-editor]'), dataDelay: 0 });
      });
    });

    root.querySelectorAll('[data-ocbc-remove-artwork]').forEach((button) => {
      button.addEventListener('click', () => {
        const editor = button.closest('[data-ocbc-zone-editor]');
        const input = editor?.querySelector('[data-ocbc-artwork-input]');
        const zoneKey = editor?.dataset.ocbcZoneEditor || '';
        clearArtworkPreview(zoneKey);
        if (input) input.value = '';
        button.hidden = true;
        const status = editor?.querySelector('[data-ocbc-file-status]');
        if (status) status.textContent = '';
        refresh({ editor, dataDelay: 0 });
      });
    });

    root.querySelectorAll('[data-ocbc-variant-id]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        root.querySelectorAll('[data-ocbc-variant-id]').forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('is-selected', active);
          candidate.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        if (variantInput) variantInput.value = button.dataset.ocbcVariantId || '';
        if (sizeProperty) sizeProperty.value = button.dataset.ocbcVariantTitle || '';
        priceOutputs.forEach((output) => {
          output.textContent = button.dataset.ocbcVariantPrice || '';
        });
        if (comparePriceOutput) {
          comparePriceOutput.textContent = button.dataset.ocbcVariantComparePrice || '';
          comparePriceOutput.hidden = !button.dataset.ocbcVariantComparePrice;
        }
        refresh({ visual: false, dataDelay: 0 });
      });
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        const buttons = Array.from(root.querySelectorAll('[data-ocbc-variant-id]:not([disabled])'));
        if (!buttons.length) return;
        event.preventDefault();
        const currentIndex = buttons.indexOf(button);
        const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
        const nextIndex = event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? buttons.length - 1
            : (currentIndex + (forward ? 1 : -1) + buttons.length) % buttons.length;
        buttons[nextIndex]?.focus();
        buttons[nextIndex]?.click();
      });
    });

    madeToggle?.addEventListener('change', () => {
      syncMadeToMeasure({ clearDisabled: !madeToggle.checked });
      refresh({ visual: false, dataDelay: 0 });
    });

    measurements?.querySelectorAll('[data-ocbc-measure-input]').forEach((field) => {
      field.addEventListener('input', () => refresh({ visual: false }));
      field.addEventListener('change', () => refresh({ visual: false, dataDelay: 0 }));
    });

    noteInput?.addEventListener('input', () => refresh({ visual: false }));

    quantityControl?.addEventListener('input', () => {
      const quantity = Math.max(1, Number.parseInt(quantityControl.value, 10) || 1);
      quantityControl.value = String(quantity);
      if (quantityInput) quantityInput.value = String(quantity);
    });

    root.querySelectorAll('[data-ocbc-edit-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = root.querySelector(`#${root.id}-${button.dataset.ocbcEditStep}`);
        if (!step) return;
        step.open = true;
        step.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('[data-ocbc-zoom]').forEach((button) => {
      button.addEventListener('click', () => {
        zoom += button.dataset.ocbcZoom === 'in' ? 0.08 : -0.08;
        zoom = Math.min(1.28, Math.max(0.82, zoom));
        if (preview) preview.style.setProperty('--ocbc-zoom', zoom.toFixed(2));
      });
    });

    root.querySelector('[data-ocbc-reset]')?.addEventListener('click', () => {
      zoom = 1;
      if (preview) preview.style.setProperty('--ocbc-zoom', '1');
      setView('front');
    });

    addAnotherButton?.addEventListener('click', () => {
      if (isSubmitting || !form) return;
      if (!validateBeforeSubmit()) return;
      resetAfterAdd = true;

      if (addToCartButton) {
        form.requestSubmit(addToCartButton);
      } else {
        form.requestSubmit();
      }
    });

    form?.addEventListener('submit', (event) => {
      if (isSubmitting) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (!validateBeforeSubmit()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      setSubmitting(true);
    }, true);

    addToCartButton?.addEventListener('click', (event) => {
      if (isSubmitting) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      resetAfterAdd = false;
      if (!validateBeforeSubmit()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    form?.addEventListener('formdata', (event) => {
      const emptyPropertyKeys = new Set();
      const helperKeys = new Set();

      for (const [key, value] of event.formData.entries()) {
        if (key.startsWith('ocbc_')) {
          helperKeys.add(key);
          continue;
        }
        if (!key.startsWith('properties[')) continue;

        const emptyText = typeof value === 'string' && !value.trim();
        const emptyFile = value instanceof File && !value.name && value.size === 0;
        if (emptyText || emptyFile) emptyPropertyKeys.add(key);
      }

      helperKeys.forEach((key) => event.formData.delete(key));
      emptyPropertyKeys.forEach((key) => event.formData.delete(key));
    });

    productForm?.addEventListener('cart:update', (event) => {
      if (event.detail?.data?.didError) {
        setSubmitting(false);
        resetAfterAdd = false;
        showValidation(['The jacket could not be added to cart. Please review your selections and try again.']);
        return;
      }

      setSubmitting(false);
      setTimeout(() => {
        if (resetAfterAdd) {
          resetCustomizer();
          if (successPanel) {
            successPanel.hidden = false;
            const successMessage = successPanel.querySelector('p');
            if (successMessage) successMessage.textContent = 'Jacket added. The customizer is ready for another design.';
          }
        } else if (successPanel) {
          successPanel.hidden = false;
          const successMessage = successPanel.querySelector('p');
          if (successMessage) successMessage.textContent = 'Custom bomber jacket added to cart.';
        }
        resetAfterAdd = false;
      }, 120);
    });

    productForm?.addEventListener('cart:error', (event) => {
      setSubmitting(false);
      resetAfterAdd = false;
      const message = event.detail?.data?.message || 'The jacket could not be added to cart. Please try again.';
      showValidation([message]);
    });

    saveButton?.addEventListener('click', () => {
      refresh({ immediate: true });
      try {
        localStorage.setItem(storageKey, JSON.stringify(state));
        updateSavedControls();
        if (previewStatus) previewStatus.textContent = 'Design saved on this device.';
      } catch (error) {
        if (previewStatus) previewStatus.textContent = 'This browser could not save the design.';
      }
    });

    restoreButton?.addEventListener('click', restoreSavedDesign);
    clearSavedButton?.addEventListener('click', () => {
      try { localStorage.removeItem(storageKey); } catch (error) { /* Storage may be unavailable. */ }
      updateSavedControls();
    });
    successResetButton?.addEventListener('click', resetCustomizer);

    root.querySelectorAll('[data-ocbc-color-target].is-selected').forEach(applyColorSelection);
    updateReferenceMode();
    syncMadeToMeasure();
    updateSavedControls();
    setActiveZone('right_chest', false);
    refresh({ immediate: true });
  };

  const initAllCustomizers = (scope = document) => {
    scope.querySelectorAll('[data-orlaven-custom-bomber]').forEach(initCustomizer);
  };

  initAllCustomizers();
  document.addEventListener('shopify:section:load', (event) => initAllCustomizers(event.target));
  } catch(e) { console.error(e); }
})();

})();
